import { Component } from '@theme/component';

class KGDescriptionToggle extends Component {
  #controller;
  #tail;
  #button;

  connectedCallback() {
    super.connectedCallback();
    this.#initialize();
  }

  updatedCallback() {
    super.updatedCallback();
    this.#initialize();
  }

  disconnectedCallback() {
    this.#controller?.abort();
    super.disconnectedCallback();
  }

  #initialize() {
    this.#controller?.abort();
    const content = this.querySelector('.text-block');
    if (!content) return;

    let tail = content.querySelector(':scope > .kg-description-tail');
    let button = this.querySelector(':scope > .kg-description-button');
    if (!tail) {
      const heading = Array.from(content.children).find((element) => {
        const text = element.textContent.trim().replace(/[’‘]/g, "'").replace(/\s+/g, ' ').toLowerCase();
        return /^(what's|whats) inside:?$/.test(text);
      });
      if (!heading || !heading.nextSibling) {
        button?.remove();
        return;
      }
      tail = document.createElement('div');
      tail.className = 'kg-description-tail';
      tail.id = this.dataset.contentId;
      content.insertBefore(tail, heading.nextSibling);
      while (tail.nextSibling) tail.appendChild(tail.nextSibling);

      if (!button) {
        button = document.createElement('button');
        button.type = 'button';
        button.className = 'button button-secondary kg-description-button';
        this.appendChild(button);
      }
      button.setAttribute('aria-controls', tail.id);
      button.setAttribute('aria-expanded', 'false');
    }
    if (!button) return;
    this.#tail = tail;
    this.#button = button;
    this.#setExpanded(button.getAttribute('aria-expanded') === 'true');
    this.#controller = new AbortController();
    button.addEventListener('click', () => {
      this.#setExpanded(button.getAttribute('aria-expanded') !== 'true');
    }, { signal: this.#controller.signal });
  }

  #setExpanded(expanded) {
    if (!this.#tail || !this.#button) return;
    this.#tail.inert = !expanded;
    if (expanded) this.#tail.removeAttribute('aria-hidden');
    else this.#tail.setAttribute('aria-hidden', 'true');
    this.toggleAttribute('data-collapsed', !expanded);
    this.#button.setAttribute('aria-expanded', String(expanded));
    this.#button.textContent = expanded ? this.dataset.lessLabel : this.dataset.moreLabel;
  }
}

if (!customElements.get('kg-description-toggle')) {
  customElements.define('kg-description-toggle', KGDescriptionToggle);
}
